module.exports = __webpack_public_path__ + "img/icons8-sales-performance-100.8bf20759.png";